import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select } from 'antd';
import {
  CaretDown,
  CaretUp,
  FunnelSimple,
  X,
} from '@phosphor-icons/react';

import DatePicker from '../../../../components/DatePicker';
import {
  getCompactMultiSelectMaxTagCount,
  getCompactMultiSelectPlaceholder,
} from '../../../../utils/compactMultiSelect';

const UploadedPrimaryFilters = ({
  optimisticParams,
  searchValue,
  dobValue,
  dateFormat,
  sortValue,
  sortOptions,
  archivedOptions,
  scopeValue,
  scopeOptions,
  departmentOptions,
  categoryOptions,
  selectedDepartments,
  showMoreFilters,
  hasSecondaryFilters,
  activeFilterCount,
  handlers,
}) => {
  const { search, searchChange } = handlers;

  return (
    <div className="referral-filter-bar__row uploaded-records-filter-bar__row">
      <Input.Search
        className="referral-filter-bar__search uploaded-records-filter-bar__search"
        placeholder="Search uploads..."
        data-tutorial="record-search"
        allowClear
        value={searchValue}
        onChange={searchChange}
        onSearch={search}
      />

      <DatePicker
        className="referral-filter-bar__date uploaded-records-filter-bar__dob"
        placeholder="DOB"
        format={dateFormat}
        value={dobValue}
        onChange={handlers.dobChange}
      />

      <Select
        className="referral-filter-bar__select"
        aria-label="Sort uploads"
        value={sortValue}
        onChange={handlers.sortChange}
        options={sortOptions}
      />

      <Select
        className="referral-filter-bar__select"
        aria-label="Record status"
        data-tutorial="record-filters"
        value={optimisticParams.archived ? 'archived' : 'active'}
        onChange={handlers.archivedChange}
        options={archivedOptions}
      />

      <Select
        className="referral-filter-bar__select"
        aria-label="Record scope"
        value={scopeValue}
        onChange={handlers.scopeChange}
        options={scopeOptions}
      />

      {departmentOptions.length > 1 && (
        <Select
          className="referral-filter-bar__select compact-multi-select"
          mode="multiple"
          placeholder="Department"
          value={selectedDepartments}
          onChange={handlers.departmentChange}
          options={departmentOptions}
          allowClear
          showSearch
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
          maxTagCount={getCompactMultiSelectMaxTagCount(selectedDepartments)}
          maxTagPlaceholder={getCompactMultiSelectPlaceholder('departments')}
        />
      )}

      <Select
        aria-label="Document category"
        className="referral-filter-bar__select"
        placeholder="Category"
        value={optimisticParams.category || undefined}
        onChange={handlers.categoryChange}
        options={categoryOptions}
        allowClear
        showSearch
        filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
      />

      <button
        type="button"
        className={`referral-filter-bar__more-btn${showMoreFilters || hasSecondaryFilters ? ' referral-filter-bar__more-btn--active' : ''}`}
        onClick={handlers.toggleMoreFilters}
      >
        <FunnelSimple size={15} weight={showMoreFilters ? 'fill' : 'regular'} />
        <span>Filters</span>
        {showMoreFilters ? <CaretUp size={11} /> : <CaretDown size={11} />}
      </button>

      {activeFilterCount > 0 && (
        <button
          type="button"
          className="referral-filter-bar__clear-btn"
          onClick={handlers.clearAll}
        >
          <X size={12} />
          <span>Clear all</span>
        </button>
      )}
    </div>
  );
};

UploadedPrimaryFilters.propTypes = {
  optimisticParams: PropTypes.object.isRequired,
  searchValue: PropTypes.string.isRequired,
  dobValue: PropTypes.object,
  dateFormat: PropTypes.array.isRequired,
  sortValue: PropTypes.string.isRequired,
  sortOptions: PropTypes.array.isRequired,
  archivedOptions: PropTypes.array.isRequired,
  scopeValue: PropTypes.string.isRequired,
  scopeOptions: PropTypes.array.isRequired,
  departmentOptions: PropTypes.array.isRequired,
  categoryOptions: PropTypes.array.isRequired,
  selectedDepartments: PropTypes.array.isRequired,
  showMoreFilters: PropTypes.bool.isRequired,
  hasSecondaryFilters: PropTypes.bool.isRequired,
  activeFilterCount: PropTypes.number.isRequired,
  handlers: PropTypes.object.isRequired,
};

UploadedPrimaryFilters.defaultProps = {
  dobValue: null,
};

export default UploadedPrimaryFilters;
